/* src/app/front-layout/eleven-plus-cw/eleven-plus-cw.component.css */
.btn {
  background: #0B7AB5;
  color: #ffffff;
  padding: 12px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  display: inline-block;
}
.btn:hover {
  background: #075681;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(46, 173, 247, 0.3);
}
.hero-container {
  width: 100%;
  height: 100vh;
  background: #0B7AB5;
  padding-top: 150px;
}
.hero {
  padding: 80px 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 15px;
  background: #FFBF00;
}
.hero-content h1 {
  font-size: 48px;
  color: #0B7AB5;
  margin-bottom: 20px;
  line-height: 1.2;
  font-weight: 700;
}
.hero-content p {
  font-size: 18px;
  color: #666;
  margin-bottom: 15px;
}
.exam-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 25px 0;
}
.badge {
  background: #FFBF00;
  color: rgb(5, 5, 5);
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
}
.schedule-box {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  margin: 30px 0;
}
.schedule-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 15px 0;
  font-size: 18px;
}
.icon {
  font-size: 24px;
}
.hero-image {
  position: relative;
}
.hero-image img {
  width: 100%;
  border-radius: 20px;
  max-height: 600px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}
.floating-element {
  position: absolute;
  background: #FF9F43;
  width: 60px;
  height: 60px;
  border-radius: 15px;
  animation: float 3s ease-in-out infinite;
}
.float-1 {
  top: -20px;
  right: -20px;
}
.float-2 {
  bottom: -20px;
  left: -20px;
  background: #0B7AB5;
}
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}
.section {
  padding: 20px 50px;
  max-width: 1400px;
  margin: 0 auto;
}
.section-title {
  font-size: 42px;
  text-align: center;
  margin-bottom: 50px;
  color: #2D2D2D;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 50px 0;
}
.benefit-card {
  background: white;
  padding: 35px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}
.benefit-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}
.benefit-card h3 {
  color: #0B7AB5;
  font-size: 24px;
  margin-bottom: 15px;
}
.dark-section {
  background: #0B7AB5;
  color: white;
  padding: 80px 50px;
}
.program-overview {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}
.po-img img {
  width: 100%;
  height: 600px;
  border-radius: 15px;
  object-fit: cover;
}
.included-list {
  list-style: none;
}
.included-list li {
  padding: 12px 0;
  padding-left: 35px;
  position: relative;
  font-size: 18px;
}
.included-list li:before {
  content: "\2714";
  position: absolute;
  left: 0;
  color: #0B7AB5;
  font-weight: bold;
  font-size: 20px;
}
.pricing-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin: 50px 0;
}
.pricing-card {
  background: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}
.pricing-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background:
    linear-gradient(
      90deg,
      #0B7AB5,
      #FFBF00);
}
.plan-number {
  font-size: 48px;
  color: #FF9F43;
  font-weight: bold;
  margin-bottom: 10px;
}
.pricing-card h3 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #2D2D2D;
}
.price {
  font-size: 36px;
  color: #0B7AB5;
  font-weight: bold;
  margin: 20px 0;
}
.price-alt {
  font-size: 20px;
  color: #666;
  margin-bottom: 25px;
}
.cta-section {
  background:
    linear-gradient(
      135deg,
      #0B7AB5,
      #FF9F43);
  padding: 80px 50px;
  text-align: center;
  color: white;
}
.cta-section h2 {
  font-size: 48px;
  margin-bottom: 20px;
}
.cta-section p {
  font-size: 24px;
  margin-bottom: 40px;
}
.btn-white {
  background: white;
  color: #2D2D2D;
}
@media (max-width: 968px) {
  .hero,
  .program-overview {
    grid-template-columns: 1fr;
  }
  .benefits-grid,
  .pricing-cards {
    grid-template-columns: 1fr;
  }
  .hero-content h1 {
    font-size: 36px;
  }
  .section-title {
    font-size: 32px;
  }
}
/*# sourceMappingURL=eleven-plus-cw.component.css.map */
